import { _ } from "i18n";
import { useState, type MutableRefObject } from "react";
import { EventCommentItem, TeamPlayer, EventComment } from "../../../types";
import { CommonModal } from "../../../../../../ui-kit-v2/src/modal/common-modal";
import { EditableComment } from "./EditableComment";
import { FormApi } from "final-form";
import { useFullscreenModalContainer } from "../../../useFullscreenModalContainer";

export interface VideoCommentsListProps {
	comments: EventCommentItem[];
	teamPlayers: TeamPlayer[];
	eventId: number;
	onDeleteComment: (commentId: number, eventId: number) => void;
	onEditComment: (commentId: number, data: any) => void;
	editFormRef?: MutableRefObject<FormApi<EventComment> | null>;
}

function commentCreatedAtTimestamp(isoString: string): number {
	return new Date(isoString).getTime();
}

export function VideoCommentsList({ comments, onDeleteComment, onEditComment, eventId, teamPlayers, editFormRef }: VideoCommentsListProps) {
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);
	const [commentIdToDelete, setCommentIdToDelete] = useState<number | null>(null);
	const fullscreenModalContainer = useFullscreenModalContainer();

	const handleDeleteComment = (commentId: number) => {
		setShowDeleteDialog(true);
		setCommentIdToDelete(commentId);
	};

	return (
		<>
			<div>

				<div className="space-y-6">
					{[...comments]
						.sort((a, b) => commentCreatedAtTimestamp(b.createdAt) - commentCreatedAtTimestamp(a.createdAt))
						.map((comment) => (
							<EditableComment
								key={comment.id}
								comment={comment}
								teamPlayers={teamPlayers}
								onEdit={onEditComment}
								onDelete={handleDeleteComment}
								editFormRef={editFormRef}
							/>
						))}
				</div>
			</div>

			<CommonModal
				show={showDeleteDialog}
				onClose={() => setShowDeleteDialog(false)}
				title={_("discover.modal.confirm.title")}
				size="sm"
				UNSTABLE_portalContainer={fullscreenModalContainer}
				primaryButton={{
					text: _("discover.button.deleteComment.confirm"),
					onClick: () => {
						if (commentIdToDelete !== null) {
							onDeleteComment(commentIdToDelete, eventId);
							setShowDeleteDialog(false);
							setCommentIdToDelete(null);
						}
					},
				}}
				secondaryButton={{
					text: _("discover.button.cancel"),
					onClick: () => {
						setShowDeleteDialog(false);
						setCommentIdToDelete(null);
					},
				}}
			>
				<div>{_("discover.button.deleteComment.text")}</div>
			</CommonModal>
		</>
	);
}
